module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-409.8dced56.woff2";